export const GAME_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'VideoGame',
  name: 'LUDOKA',
  description:
    "Jeu de Ludo sur le theme du football integre a l'ecosysteme SOKA. Jouez gratuitement ou pariez des SOKA Points dans des parties multijoueur en temps reel.",
  url: 'https://ludoka.soka.club',
  image: 'https://ludoka.soka.club/pwa-512x512.png',
  gamePlatform: 'Web Browser',
  applicationCategory: 'Game',
  operatingSystem: 'Any',
  numberOfPlayers: {
    '@type': 'QuantitativeValue',
    minValue: 2,
    maxValue: 4
  },
  genre: ['Board Game', 'Strategy'],
  publisher: {
    '@type': 'Organization',
    name: 'SOKA',
    url: 'https://soka.club'
  },
  offers: {
    '@type': 'Offer',
    price: '0',
    priceCurrency: 'USD',
    availability: 'https://schema.org/InStock'
  }
} as const;
